"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Container = _styledComponents["default"].div.withConfig({
  displayName: "Options__Container",
  componentId: "qgikjq-0"
})(["display:flex;flex-direction:column;justify-content:flex-end;background-color:#344563;border-radius:4px !important;"]);

var Option = _styledComponents["default"].button.withConfig({
  displayName: "Options__Option",
  componentId: "qgikjq-1"
})(["height:25px;font-size:12px;font-style:normal;font-weight:700;line-height:16px;letter-spacing:0em;text-align:center;color:white;cursor:pointer;padding-left:10px;background:transparent;border:none;outline:none;border-radius:4px;:hover{background-color:#5c6a82;}"]);

function Options(_ref) {
  var options = _ref.options,
      onClose = _ref.onClose;
  return /*#__PURE__*/_react["default"].createElement(Container, null, options.map(function (_ref2) {
    var label = _ref2.label,
        onClick = _ref2.onClick;

    var handleOnClick = function handleOnClick(event) {
      event.preventDefault();
      onClose();
      onClick();
    };

    return /*#__PURE__*/_react["default"].createElement(Option, {
      key: label,
      onClick: handleOnClick
    }, label);
  }));
}

var _default = Options;
exports["default"] = _default;